import { Routes } from '@angular/router';
import { getTokenResolver } from '@shared/services/get-token-resolver';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/detail/detail.routes'),
    resolve: { token: getTokenResolver },
  },
];
